import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as pageActions from "redux/actions/pageActions";
import TmeHome from "./TmeHome";
import { Skeleton } from "@mui/material";

const Home = () => {
  const dispatch = useDispatch();
  const [isloading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const selectedClient = useSelector(state => state.clients.selectedClient);
  const selectedClientId = useSelector(state => state.clients.selectedClientId);

  useEffect(() => {
    if (selectedClient?.clientId) {
      setLoading(true);
      dispatch(pageActions.getHomePageData(selectedClient.clientId))
        .catch(e => {
          setError(e);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [dispatch, selectedClientId, selectedClient]);

  if (isloading) {
    return <Skeleton sx={{ height: "150px" }} />;
  }
    return <TmeHome isloading={isloading} />;
}
export default Home;
